<template>
  <div>
    <tabs v-model="active" @change="tabChange">
      <tab
        v-for="(item, index) in tabList"
        :key="index"
        :name="item.key"
        :title="item.name"
      ></tab>
    </tabs>

    <List
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getList"
    >
      <div v-for="(item, index) in list" class="item ub" :key="index">
        <img
          :src="
            item.gift_status.key === 'WAIT' ? logoImg.online : logoImg.offline
          "
          class="logo"
        />
        <div class="uf1">
          <div class="ub ub-sb header">
            <div :class="['title', item.gift_status.key]">
              【活动】买一赠一
            </div>
            <span :class="['status', item.gift_status.key]">
              {{ item.gift_status.text }}
            </span>
          </div>
          <div class="intro">获得商品买一送一的机会</div>
          <div class="fg"></div>
          <div class="ecffet" v-if="item.gift_status.key === 'USE'">
            {{ item.parent_gift_use_time }} 使用
          </div>
          <div v-else class="ub ub-sb">
            <div class="ecffet">有效期至 {{ item.gift_end_time_f }}</div>

            <count-down
              :time="item.gift_end_time_dt"
              format="DD 天 HH 时 mm 分 ss 秒"
            >
            </count-down>
          </div>
        </div>
      </div>
    </List>
  </div>
</template>

<script>
import { getGiftList } from "@api/order";
import { List, CountDown, Tab, Tabs } from "vant";
export default {
  name: "Index",
  components: {
    Tab,
    Tabs,
    List,
    CountDown
  },
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      list: [],
      logoImg: {
        online:
          "//aijiutang.oss-cn-beijing.aliyuncs.com/work_time/assets/images/gift.png",
        offline:
          "//aijiutang.oss-cn-beijing.aliyuncs.com/work_time/assets/images/gift_off.png"
      },
      tabList: [
        {
          key: "WAIT",
          name: "待使用"
        },
        {
          key: "USE",
          name: "已使用"
        },
        {
          key: "EFFECT",
          name: "已过期"
        }
      ],
      active: 0,
      query: {
        page: 1,
        page_size: 10,
        gift_status: "WAIT"
      }
    };
  },
  mounted() {
    // this.getList();
  },
  methods: {
    tabChange(name) {
      this.query.gift_status = name;
      this.getList(true);
    },
    getList(flag) {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      }
      if (flag) this.query.page = 1;
      getGiftList(this.query)
        .then(({ data }) => {
          if (flag) this.list = [];
          if (data.length < this.query.page_size) {
            this.finished = true;
          }
          this.list.push.apply(this.list, data);
          this.query.page++;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped lang="scss">
.item {
  box-sizing: border-box;
  background: #ffffff;
  margin: 15px;
  padding: 15px;
  border-radius: 10px;
  .logo {
    width: 1rem;
    height: 1rem;
    margin-right: 0.2rem;
  }
  .header {
    margin-bottom: 10px;
  }
  .title {
    font-size: 0.4rem;
    &.USE {
      color: #cccccc;
    }
    &.EFFECT {
      color: #cccccc;
    }
  }
  .intro {
    font-size: 0.23rem;
    color: #999999;
  }
  .fg {
    border-top: 1px dashed #cccccc;
    margin: 0.2rem 0;
  }
  .status {
    &.WAIT {
      color: #1abb1d;
    }
    &.USE {
      color: red;
    }
    &.EFFECT {
      color: #cccccc;
    }
  }
  .ecffet {
    font-size: 0.23rem;
    color: #999999;
  }
}
</style>
